<!-- gmail-closed-open-01-desktop preview — Gmail ad, toggle between the collapsed inbox row and the expanded message -->
<div class="gs-state-toggle d-flex flex-row justify-content-center">
  <button
    type="button"
    class="gs-state-tab"
    [class.active]="view === 'closed'"
    (click)="selectView('closed')"
  >
    Closed
  </button>
  <button
    type="button"
    class="gs-state-tab"
    [class.active]="view === 'open'"
    (click)="selectView('open')"
  >
    Open
  </button>
</div>

<app-desktop-frame>
  <div class="gs-page d-flex flex-row">
    <!-- START: Gmail rail -->
    <div class="gs-rail d-flex flex-column align-items-center" aria-hidden="true">
      <i class="bi bi-list gs-menu"></i>
      <span class="gs-rail-panel"></span>
    </div>
    <!-- END: Gmail rail -->

    <!-- START: Gmail main content -->
    <div class="gs-main d-flex flex-column">
      <!-- START: Gmail header -->
      <div class="gs-header d-flex flex-row align-items-center" aria-hidden="true">
        <div class="gs-brand d-flex flex-row align-items-center">
          <svg class="gs-logo" viewBox="52 42 88 66" aria-hidden="true" focusable="false">
            <path fill="#4285f4" d="M58 108h14V74L52 59v43c0 3.32 2.69 6 6 6"/>
            <path fill="#34a853" d="M120 108h14c3.32 0 6-2.69 6-6V59l-20 15"/>
            <path fill="#fbbc04" d="M120 48v26l20-15v-8c0-7.42-8.47-11.65-14.4-7.2"/>
            <path fill="#ea4335" d="M72 74V48l24 18 24-18v26L96 92"/>
            <path fill="#c5221f" d="M52 51v8l20 15V48l-5.6-4.2c-5.94-4.45-14.4-.22-14.4 7.2"/>
          </svg>
          <span class="gs-wordmark">Gmail</span>
        </div>
        <div class="gs-search d-flex flex-row align-items-center">
          <i class="bi bi-search"></i>
          <span class="gs-search-bar"></span>
          <i class="bi bi-sliders gs-search-filter"></i>
        </div>
      </div>
      <!-- END: Gmail header -->

      <!-- START: Gmail card -->
      <div class="gs-card">
        <!-- START: Closed state -->
        <div *ngIf="view === 'closed'">
          <div class="gs-inbox">
            <!-- START: Gmail tabs -->
            <div class="gs-tabs d-flex flex-row" aria-hidden="true">
              <div class="gs-tab d-flex flex-row align-items-center">
                <i class="bi bi-inbox-fill"></i>
                <span class="gs-tab-bar"></span>
              </div>
              <div class="gs-tab d-flex flex-row align-items-center active">
                <i class="bi bi-tag"></i>
                <span class="gs-tab-bar"></span>
              </div>
              <div class="gs-tab d-flex flex-row align-items-center">
                <i class="bi bi-chat-left-text"></i>
                <span class="gs-tab-bar"></span>
              </div>
            </div>
            <!-- END: Gmail tabs -->

            <!-- START: Ad row -->
            <div class="gs-row d-flex flex-row align-items-center">
              <i class="bi bi-star gs-row-star"></i>
              <span class="gs-row-sender">Valamar</span>
              <div class="gs-row-subject">
                <span class="gs-row-label">Sponsored</span>
                <span class="gs-row-sep">•</span>
                <a [href]="data.url || null" target="_blank" rel="noopener noreferrer" class="gs-row-headline">{{ headline }}</a>
                <span class="gs-row-snippet"> - {{ description }}</span>
              </div>
              <i class="bi bi-three-dots-vertical gs-row-menu"></i>
            </div>
            <!-- END: Ad row -->
          </div>
        </div>
        <!-- END: Closed state -->

        <!-- START: Open state -->
        <div *ngIf="view === 'open'">
          <div class="gs-message">
            <!-- START: Message toolbar -->
            <div class="gs-toolbar d-flex flex-row align-items-center" aria-hidden="true">
              <i class="bi bi-arrow-left"></i>
              <i class="bi bi-archive"></i>
              <i class="bi bi-exclamation-octagon"></i>
              <i class="bi bi-trash"></i>
            </div>
            <!-- END: Message toolbar -->

            <!-- START: Sender info -->
            <div class="gs-sender d-flex flex-row align-items-center">
              <span class="gs-sender-logo" aria-hidden="true">V</span>
              <span class="gs-sender-name">Valamar</span>
              <i class="bi bi-three-dots-vertical gs-sender-menu"></i>
            </div>
            <!-- END: Sender info -->

            <!-- START: Message body -->
            <div class="gs-body d-flex flex-row justify-content-center">
              <a [href]="data.url || null" target="_blank" rel="noopener noreferrer" class="gs-creative">
                <img *ngIf="creativeImage" class="gs-creative-image" [src]="creativeImage" alt="" />
                <div *ngIf="!creativeImage" class="gs-creative-image creative-missing">{{ missingDimensionLabel }}</div>
              </a>
              <div class="gs-copy d-flex flex-column align-items-start">
                <div class="gs-desc">{{ description }}</div>
                <a [href]="data.url || null" target="_blank" rel="noopener noreferrer" class="gs-cta">{{ ctaText }}</a>
              </div>
            </div>
            <!-- END: Message body -->
          </div>
        </div>
        <!-- END: Open state -->
      </div>
      <!-- END: Gmail card -->
    </div>
    <!-- END: Gmail main content -->
  </div>
</app-desktop-frame>
